import React from "react";
import CookieConsent from "react-cookie-consent";
import { Link } from "react-router-dom";

const CookieConsentComponent = () => {
  return (
    <CookieConsent
      style={{ background: "#000" }}
      overlay
      buttonText="I understand and accept"
      buttonStyle={{
        background: "#dc0d18",
        color: "white",
        borderRadius: "12px",
        fontWeight: 600,
        fontSize: "14px",
        lineHeight: "20px",
        fontStyle: "normal",
        padding: "8px 18px",
        border: 0,
        letterSpacing: "0.0115em",
      }}
      cookieName="avitech-cookie"
    >
      <div>Cookie Policy</div>
      These cookies are used to collect information about how you interact with
      our website and allow us to remember you.
      <br /> We use this information in order to improve and customize your
      browsing experience and for analytics and metrics. <br /> For information
      about our cookies. By continuing, you agree to{" "}
      <Link to="/cookie-policy" style={{ color: "#dc0d18" }}>
        <b className="cliqki-pointer">AviTech's cookie policy</b>{" "}
      </Link>
      and{" "}
      <Link to="/privacy-policy" style={{ color: "#dc0d18" }}>
        <b className="cliqki-pointer">AviTech's privacy policy</b>
      </Link>
    </CookieConsent>
  );
};

export default CookieConsentComponent;



// WEBPACK FOOTER //
// ./src/views/home/cookie-consent.js